export const fieldClass =
  "w-full bg-slate-800 border border-slate-700 rounded-md px-3 py-2 text-sm text-slate-100 outline-none focus:border-primary";

export const emptyRiga = { prodotto: "", prodotto_originale: "", quantita: "", unita: "colli", prezzo_unitario: "", importo: "", iva: "" };

export const rowTotal = (r) =>
  r.importo !== "" && r.importo != null
    ? parseFloat(r.importo) || 0
    : (parseFloat(r.quantita) || 0) * (parseFloat(r.prezzo_unitario) || 0);

export const rowCoherent = (r) => {
  const imp = parseFloat(r.importo);
  if (!imp || isNaN(imp)) return true;
  const calc = (parseFloat(r.quantita) || 0) * (parseFloat(r.prezzo_unitario) || 0);
  if (!calc) return true;
  return Math.abs(imp - calc) <= Math.max(0.05, imp * 0.02);
};
